import classNames from 'classnames';
import React from 'react';
import styles from './ItemList.module.scss';

interface Props<T> {
  items: T[];
  renderItem: (item: T) => React.ReactNode;
  onSelect(item: T): void;
  ordered?: boolean;
}

export function ItemList<T>({items, renderItem, onSelect, ordered}: Props<T>) {
  const itemClassName = classNames(styles.Tr, ordered && styles.ordered);

  const itemMarkup = items.map((item: T) => {
    return (
      <tr className={itemClassName} onClick={() => onSelect(item)}>
        {renderItem(item)}
      </tr>
    );
  });
  return <tbody>{itemMarkup}</tbody>;
}
